import { render } from "./Initials.vue?vue&type=template&id=1aa105ec&scoped=true"
import script from "./Initials.vue?vue&type=script&lang=js"
export * from "./Initials.vue?vue&type=script&lang=js"

import "./Initials.vue?vue&type=style&index=0&id=1aa105ec&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-1aa105ec"

export default script